import MegaOptionsContainer from "../../Componant/FormControl/MegaOptions";

const MegaOptions = () => {
  return (
    <div className="page-body">
      <MegaOptionsContainer />
    </div>
  );
};

export default MegaOptions;
